module.exports = __webpack_public_path__ + "img/single.d0a76947.jpg";